import React from 'react'
import { useNavigate } from 'react-router-dom';
import Adminnav from '../Adminnav';
const DistributionHubConfig = () => {
    var nav = useNavigate()
    function navAddHub(){
      nav('/AdminPanel/UserConfig/DistributionHubConfig/AddHub')
    }
    function navRemoveHub(){
      nav('/AdminPanel/UserConfig/DistributionHubConfig/RemoveHub')
    }
  return (
   <>
   <Adminnav/>
    <div className="card h-100 text-center panel" >
                <div className="card-body row ">
                <i className="fas fa-user-plus col icons"  onClick={()=>navAddHub()}></i>
                <i className="fas fa-user-slash col icons" onClick={()=>navRemoveHub()}></i>
                </div>
                <div className="card-body row content">
                <b className="col" style={{paddingLeft:"3.0px"}}>Add Distribution Hub</b>
                <b className="col" style={{marginLeft:"25px"}}>Remove Distribution Hub</b>
                </div>
            </div>
   </>
  )
}

export default DistributionHubConfig